import React from "react";
import Home from "./Home";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "./index.css";
import { BrowserRouter as Router, Route, Routes, Outlet } from "react-router-dom";
import Favourites from "./Favourites";
import Login from "./pages/Login";
import ForgetPassword from "./pages/ForgetPassword";
import SignIn from "./pages/SignIn";
import Register from "./pages/Register";
import ConfirmReg from "./pages/ConfirmReg";
import ChangePass from "./pages/ChangePass";
import Cardetail from "./components/Cardetail";
import MyListing from "./dashPages/MyListing";
import ListDetails from "./dashPages/ListDetails";
import ListedPreview from "./dashPages/ListedPreview";
import UnlockReq from "./dashPages/UnlockReq";
import PendingUnlocks from "./dashPages/PendingUnlocks";
import UnlockedCars from "./dashPages/UnlockedCars";
import MyCredits from "./dashPages/MyCredits";
import ProfileSetting from "./dashPages/ProfileSetting";
import DeleteAccount from "./dashPages/DeleteAccount";
import ListMyCar from "./components/ListMyCar";
import BuyPlan from "./dashPages/BuyPlan";
import PaymentDetails from "./dashPages/PaymentDetails";
import Logout from "./pages/Logout";
import PurchaseCredit from "./dashPages/PurchaseCredit";
import AppRequests from "./dashPages/AppUnlockReq";
import Cardetail1 from "./components/Cardetail1";
import FilterCarData from "./components/FilterCarData";
import RejectedRequest from "./dashPages/RejectedRequest";
import ScrollToTop from "./ScrollToTop";
import ThankYou from "./pages/ThankYou";
import CreditSuccess from "./pages/CreditSuccess";
import DealerRegistration from "./pages/DealerRegistration";
import EditCar from "./dashPages/EditCar";
import TermsConditions from "./pages/TermsConditions";
import RejectedRequestBuyer from "./dashPages/RejectedRequestBuyer";
import AcceptOffer from "./pages/AcceptOffer";
import RejectOffer from "./pages/RejectOffer";
import MyInventory from "./dealer/MyInventory";
import MyUnlockRequest from "./dealer/MyUnlockRequest";
import MyApprovedUnlockRequest from "./dealer/MyApprovedUnlockRequest";
import MyPendingUnlocks from "./dealer/MyPendingUnlocks";
import MyUnlockedCars from "./dealer/MyUnlockedCars";
import ListDealerCars from "./dealer/ListDealerCars";
import ViewMyCarlist from "./dealer/ViewMyCarlist";
import EditMySavedCar from "./dealer/EditMySavedCar";
import ViewSavedCarDetail from "./dealer/ViewSavedCarDetail";
import Dashboard from "./dealer/MyDashboard";
import AllMyCars from "./dealer/AllMyCars";
import Upgrade from "./dealer/Upgrade";
import CheckoutUpgrade from "./dealer/CheckoutUpgrade";
import SuccessfullyUpgrade from "./dealer/SuccessfullyUpgrade";
import AllMyOffers from "./dealer/AllMyOffers";
import DealerStore from "./dealer/DealerStore";
import EditDealerProfile from "./dealer/EditDealerProfile";
import EditDealerCar from "./dealer/EditDealerCar";
import RejectedOffers from "./dealer/RejectOffers";
import AcceptedOffer from "./dealer/AcceptedOffer";
import Feedback from "./pages/Feedback";
import BulkUploadCars from "./dealer/BulkUploadCars";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./components/NotFound";


const App = () => {
  return (
    <>
      {/* <Home/> */}
      <Router basename="/">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <ScrollToTop />
                <Layout>
                  <Outlet />
                </Layout>
              </>
            }
          >
            <Route exact path="/" element={<Home />} />
            <Route exact path="/home" element={<Home />} />
            <Route exact path="/FilterCarData" element={<FilterCarData />} />
            <Route exact path="/listmycar" element={<ListMyCar />} />
            <Route exact path="/fav" element={<ProtectedRoute><Favourites /></ProtectedRoute>} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/forgetpassword" element={<ForgetPassword />} />
            <Route exact path="/signin" element={<SignIn />} />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/dealer-register" element={<DealerRegistration />} />
            <Route exact path="/confreg" element={<ConfirmReg />} />
            <Route exact path="/changepass" element={<ChangePass />} />
            <Route exact path="/logout" element={<Logout />} />
            <Route exact path="/cardetails" element={<Cardetail />} />
            <Route exact path="/cardetailsNew" element={<Cardetail1 />} />
            <Route exact path="/mylisting" element={<ProtectedRoute><MyListing /></ProtectedRoute>} />
            <Route exact path="/listdetails" element={<ProtectedRoute><ListDetails /></ProtectedRoute>} />
            <Route exact path="/listpreview" element={<ProtectedRoute><ListedPreview /></ProtectedRoute>} />
            <Route exact path="/edit/mycar" element={<ProtectedRoute><EditCar /></ProtectedRoute>} />
            <Route exact path="/offers" element={<ProtectedRoute><UnlockReq /></ProtectedRoute>} />
            <Route exact path="/apprequests" element={<ProtectedRoute><AppRequests /></ProtectedRoute>} />
            <Route exact path="/pendingunlocks" element={<ProtectedRoute><PendingUnlocks /></ProtectedRoute>} />
            <Route exact path="/unlockedcars" element={<ProtectedRoute><UnlockedCars /></ProtectedRoute>} />
            <Route exact path="/mycredits" element={<ProtectedRoute><MyCredits /></ProtectedRoute>} />
            <Route exact path="/profilesetting" element={<ProtectedRoute><ProfileSetting /></ProtectedRoute>} />
            <Route exact path="/deleteAccount" element={<ProtectedRoute><DeleteAccount /></ProtectedRoute>} />
            <Route exact path="/buyplan" element={<ProtectedRoute><BuyPlan /></ProtectedRoute>} />
            <Route exact path="/paymentdetails" element={<ProtectedRoute><PaymentDetails /></ProtectedRoute>} />
            <Route exact path="/purchasecredit" element={<ProtectedRoute><PurchaseCredit /></ProtectedRoute>} />
            <Route exact path="/credits-success" element={<CreditSuccess />} />
            <Route exact path="/term-and-condition" element={<TermsConditions />} />
            <Route exact path="/accept-offer" element={<AcceptOffer />} />
            <Route exact path="/decline-offer" element={<RejectOffer />} />
            <Route exact path="/give-feedback" element={<Feedback />} />

            {/* routes for dealer */}
            <Route exact path="/dealer/my-inventory" element={<ProtectedRoute allowedRoles={["dealer"]}><MyInventory /></ProtectedRoute>} />
            <Route exact path="/dealer/unlock-requests" element={<ProtectedRoute allowedRoles={["dealer"]}><MyUnlockRequest /></ProtectedRoute>} />
            <Route exact path="/dealer/approved-unlock-request" element={<ProtectedRoute allowedRoles={["dealer"]}><MyApprovedUnlockRequest /></ProtectedRoute>} />
            <Route exact path="/dealer/pending-unlocks" element={<ProtectedRoute allowedRoles={["dealer"]}><MyPendingUnlocks /></ProtectedRoute>} />
            <Route exact path="/dealer/unlocked-cars" element={<ProtectedRoute allowedRoles={["dealer"]}><MyUnlockedCars /></ProtectedRoute>} />
            <Route exact path="/dealer/list-my-cars" element={<ProtectedRoute allowedRoles={["dealer"]}><ListDealerCars /></ProtectedRoute>} />
            <Route exact path="/dealer/bulk-upload-cars" element={<ProtectedRoute allowedRoles={["dealer"]}><BulkUploadCars /></ProtectedRoute>} />
            <Route exact path="/dealer/edit-cars" element={<ProtectedRoute allowedRoles={["dealer"]}><EditDealerCar /></ProtectedRoute>} />
            <Route exact path="/dealer/view-saved-cars" element={<ProtectedRoute allowedRoles={["dealer"]}><ViewMyCarlist /></ProtectedRoute>} />
            <Route exact path="/dealer/edit-saved/publish/cars" element={<ProtectedRoute allowedRoles={["dealer"]}><EditMySavedCar /></ProtectedRoute>} />
            {/* primary and legacy paths for saved car details */}
            <Route exact path="/dealer/saved/car/detail" element={<ProtectedRoute allowedRoles={["dealer"]}><ViewSavedCarDetail /></ProtectedRoute>} />
            <Route exact path="/dealer/ViewSavedCarDetail" element={<ProtectedRoute allowedRoles={["dealer"]}><ViewSavedCarDetail /></ProtectedRoute>} />
            <Route exact path="/dealer/dashboard" element={<ProtectedRoute allowedRoles={["dealer"]}><Dashboard /></ProtectedRoute>} />
            <Route exact path="/dealer/favourites-car" element={<ProtectedRoute allowedRoles={["dealer"]}><Favourites /></ProtectedRoute>} />
            <Route exact path="/dealer/decline-offers" element={<ProtectedRoute allowedRoles={["dealer"]}><RejectedOffers /></ProtectedRoute>} />
            <Route exact path="/dealer/accept-offers" element={<ProtectedRoute allowedRoles={["dealer"]}><MyApprovedUnlockRequest /></ProtectedRoute>} />
            <Route exact path="/dealer/approved-offers" element={<ProtectedRoute allowedRoles={["dealer"]}><MyApprovedUnlockRequest /></ProtectedRoute>} />
            <Route exact path="/dealer/accepted-offers" element={<ProtectedRoute allowedRoles={["dealer"]}><AcceptedOffer /></ProtectedRoute>} />
            <Route exact path="/dealer/edit-profile" element={<ProtectedRoute allowedRoles={["dealer"]}><ProfileSetting /></ProtectedRoute>} />
            <Route exact path="/dealer/all-cars" element={<ProtectedRoute allowedRoles={["dealer"]}><AllMyCars /></ProtectedRoute>} />
            <Route exact path="/dealer/all-offers" element={<ProtectedRoute allowedRoles={["dealer"]}><AllMyOffers /></ProtectedRoute>} />
            <Route exact path="/dealer/plans" element={<ProtectedRoute allowedRoles={["dealer"]}><Upgrade /></ProtectedRoute>} />
            <Route exact path="/dealer/checkout" element={<ProtectedRoute allowedRoles={["dealer"]}><CheckoutUpgrade /></ProtectedRoute>} />
            <Route exact path="/dealer/success" element={<ProtectedRoute allowedRoles={["dealer"]}><SuccessfullyUpgrade /></ProtectedRoute>} />
            <Route exact path="/dealer/store" element={<DealerStore />} />
            <Route exact path="/edit/dealer/profile" element={<ProtectedRoute allowedRoles={["dealer"]}><EditDealerProfile /></ProtectedRoute>} />
            <Route
              exact
              path="/rejectedrequests"
              element={<RejectedRequest />}
            />
            <Route
              exact
              path="/declined-request"
              element={<RejectedRequestBuyer />}
            />
            <Route exact path="/thankyou" element={<ThankYou />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
};
function Layout({ children }) {
  return (
    <div>
      {children}
    </div>
  );
}

export default App;
